export const milestoneDropdownOptions = {
  0: 'MilestonesSelectOptionThisWeek',
  1: 'MilestonesSelectOptionThisAndNextWeek',
  2: 'MilestonesSelectOptionNext30Days',
};
